import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  animatedVideoIcon,
  youtubeVideoIcon,
  corporateVideoIcon,
  podcastVideoIcon,
  tutorialVideoIcon,
} from "../../../../assets/icons/serviceIcon/index";
import SocialMediaVideoContent from "./SocialMediaVideoContent";

const items = [
  {
    name: "Vertical Video Editing",
    text: "Edit your clips into mobile-friendly vertical videos with proper sizing, transitions, music sync, and visuals that fit each platform’s style.",
  },
  {
    name: "Visual Enhancements & Motion Effects",
    text: "Add motion graphics, smooth transitions, text overlays, zooms, and visual effects that make your video stand out in crowded feeds.",
  },
  {
    name: "Platform-Based Output",
    text: "Deliver final videos in the right size, ratio, and quality for Instagram Reels, YouTube Shorts, Facebook, and TikTok, ready to post.",
  },
];

const otherService = [
  {
    icon: animatedVideoIcon,
    name: "Animated Videos",
    des: "Engaging animated videos that simplify ideas and grab attention.",
    path: "/animated-videos",
  },
  {
    icon: youtubeVideoIcon,
    name: "YouTube Video Editing",
    des: "Long-form YouTube videos with clean cuts, flow, and branding.",
    path: "/youtube-video-editing",
  },
  {
    icon: corporateVideoIcon,
    name: "Corporate & Business Videos",
    des: "Polished business videos for presentations and internal brand communication",
    path: "/corporate-and-business-video",
  },
  {
    icon: podcastVideoIcon,
    name: "Podcast & Interview Editing",
    des: "Clean edits, smooth flow, and visuals that make content shine.",
    path: "/podcast-and-interview-editing",
  },
  {
    icon: tutorialVideoIcon,
    name: "Explainer & Tutorial Videos",
    des: "Break down complex ideas into simple, easy-to-follow video explanations.",
    path: "/explainer-tutorial-video",
  },
];
const SocialMediaVideo = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Videos"
        description="We turn your raw footage into high-quality videos made for social platforms. Whether it’s Reels, Shorts, or TikToks, every video is edited to look smooth, clean, and on-brand."
        heading="Social Media"
      />
      <NewCommonServiceForm title="Social Media Videos" items={items} />
      <SocialMediaVideoContent/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default SocialMediaVideo;
